import React, { useEffect, useState } from 'react';
import API from 'shared/api';
import { FiUsers } from 'react-icons/fi';
import { COL } from 'shared/darkColors';
import { BarsH } from 'shared/components/Dashboard/charts';
import {
  S, money, intFmt, Kpi, SectionCard, Cargando, ErrorMsg, buildQuery, descargarCSV,
} from './reportesCommon';

export default function ReporteClientes({ filtros }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(false);
    API.get(`/reportes/clientes/resumen?${buildQuery(filtros, { limite: 20 }).toString()}`)
      .then((r) => alive && r.data.status === 'success' && setData(r.data.data))
      .catch(() => alive && setError(true))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtros.sede, filtros.fechaDesde, filtros.fechaHasta]);

  if (loading) return <Cargando />;
  if (error) return <ErrorMsg />;
  if (!data) return null;

  const exportar = () => {
    descargarCSV(
      'reporte_top_clientes.csv',
      ['Cliente', 'Teléfono', 'Monto', 'Pedidos', 'Última compra'],
      data.top_clientes.map((c) => [c.nombre, c.telefono, c.monto, c.pedidos, c.ultima])
    );
  };

  return (
    <div>
      <div style={S.kpiGrid}>
        <Kpi label="Clientes totales" value={intFmt(data.total)} color={COL.pri} />
        <Kpi label="Nuevos en el período" value={intFmt(data.nuevos)} color={COL.green} />
      </div>

      <div style={S.cardGrid}>
        <SectionCard title="Clientes por sede" icon={FiUsers} color={COL.pri2}>
          <BarsH items={data.por_sede.map((s) => ({ label: s.sede, value: s.total }))} fmt={intFmt} color={COL.pri2} />
        </SectionCard>

        <SectionCard title="Top clientes" icon={FiUsers} color={COL.pri} hint="Por monto acumulado">
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
            <button onClick={exportar} style={S.btn}>Exportar CSV</button>
          </div>
          <div style={S.tableWrap}>
            <table style={{ ...S.table, minWidth: '420px' }}>
              <thead>
                <tr>{['Cliente', 'Teléfono', 'Monto', 'Pedidos', 'Última'].map((h) => <th key={h} style={S.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {data.top_clientes.map((c) => (
                  <tr key={c.idcliente}>
                    <td style={{ ...S.td, fontWeight: 600 }}>{c.nombre}</td>
                    <td style={{ ...S.td, color: COL.muted }}>{c.telefono || '—'}</td>
                    <td style={{ ...S.td, fontWeight: 700, color: COL.green }}>{money(c.monto)}</td>
                    <td style={S.td}>{intFmt(c.pedidos)}</td>
                    <td style={{ ...S.td, color: COL.muted, fontSize: '11px' }}>{c.ultima?.slice(0, 10) || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {data.top_clientes.length === 0 && <div style={{ textAlign: 'center', padding: '20px', color: COL.muted }}>Sin compras en el período</div>}
        </SectionCard>
      </div>
    </div>
  );
}
